import create from "zustand";

import { STEP_API_ENDPOINT } from "../../utils/swr";

export type AuthStore = {
  jwt: string | null;
  setJwt: (jwt: string) => void;
  deleteJwt: () => void;
  refreshJwt: (network: string) => Promise<void>;
};

const jwtFromLocal = localStorage.getItem("jwt") || "null";

export const useStepAuthStore = create<AuthStore>((set, get) => ({
  jwt: JSON.parse(jwtFromLocal),
  setJwt: (jwt: string) => {
    set({ jwt });
    localStorage.setItem("jwt", JSON.stringify(jwt));
  },
  deleteJwt: () => {
    set({ jwt: null });
    localStorage.removeItem("jwt");
  },
  refreshJwt: async (network: string) => {
    const response = await fetch(`${STEP_API_ENDPOINT}/auth/login`, {
      method: "POST",
      body: JSON.stringify({ auth: { cluster: network } }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${get().jwt}`,
      },
    });
    const data = await response.json();
    get().setJwt(data.access_token);
  },
}));
